/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { useIntl } from 'react-intl'
import classNames from 'classnames'
import { IconLabelContent } from '../../../../common/component/IconLabelContent'
import { parseLocalDate } from '../../../../util/Locale'
import { ITaskDto } from '../Task.model'

interface Props {
  disabled?: boolean
  data: ITaskDto
  rowSelected?: string
  backgroundClass?: string
  hoverBackgroundClass?: string
  onRowClick?: (id: string) => void
  removeOnClick?: (id: string) => void
}

export const TaskListItem: FC<Props> = ({
  disabled,
  data,
  rowSelected,
  backgroundClass = 'bg-light-primary',
  hoverBackgroundClass = 'bg-hover-light-primary',
  onRowClick,
  removeOnClick,
}: Props) => {
  const intl = useIntl()
  const backGroundClasses = {}
  backGroundClasses[`d-flex flex-stack py-2 ${backgroundClass}`] = data.id === rowSelected

  const hoverBackGroundClasses = {}
  hoverBackGroundClasses[`d-flex flex-stack py-2 ${hoverBackgroundClass}`] = data.id !== rowSelected

  const buildDescriptionLine = (data: ITaskDto) => {
    let description = ``
    if (data.statusCode) {
      description += description
        ? ` | ${intl.formatMessage({id: `DROPDOWN.TASK.STATUS.${data.statusCode}`})}`
        : `${intl.formatMessage({id: `DROPDOWN.TASK.STATUS.${data.statusCode}`})}`
    }
    if (data.assignedTo) {
      description += description
        ? ` | ${data.assignedTo.email}`
        : `${data.assignedTo.email}`
    } else {
      description += description
        ? ` | <${intl.formatMessage({id: `TICKET.UNASSIGNED`})}>`
        : `<${intl.formatMessage({id: `TICKET.UNASSIGNED`})}>`
    }
    return description
  }

  return (
    <div
      className={classNames(backGroundClasses, hoverBackGroundClasses)}
      onClick={() => onRowClick && onRowClick(data.id)}
    >
      <div className='d-flex flex-stack'>
        <div className='d-flex align-items-center'>
          {!disabled && removeOnClick && (
            <div className='row'>
              <div className='d-flex justify-content-end align-items-center'>
                <button
                  type='button'
                  className='btn btn-sm btn-icon'
                  onClick={() => removeOnClick(data.id)}
                >
                  <i className='bi bi-x fs-1 fw-bold text-danger'></i>
                </button>
              </div>
            </div>
          )}

          <div className='ms-2'>
            <div className='fs-7'>
              <span className='text-primary mb-2'>
                {`${parseLocalDate(data.createdAt, intl.formatMessage({id: 'I18N.LOCALE'}))}`}
              </span>
              <span className='text-gray-800 ms-2 me-2 mb-2'>-</span>
              <span className='fw-bolder mb-2'>{`${data.title} `}</span>
              <span className='text-gray-600 ms-2 me-2 mb-2'>-</span>
              <span className='text-primary mb-2'>{data.sequence}</span>
            </div>

            <div className='d-flex justify-content-start'>
              <div className='d-flex align-items-center fs-8'>
                <span className='text-gray-600'>{buildDescriptionLine(data)}</span>
              </div>
            </div>

            <div className='d-flex justify-content-start align-items-center'>
              <IconLabelContent
                title={
                  (data.totalAttachments ?? 0) > 0
                    ? intl
                        .formatMessage({
                          id:
                            data.totalAttachments === 1
                              ? 'TITLE.ATTACHMENT.TOTAL_SINGLE'
                              : 'TITLE.ATTACHMENT.TOTAL_MULTIPLE',
                        })
                        .replace(/%s/g, `${data.totalAttachments}`)
                    : intl.formatMessage({id: 'TITLE.ATTACHMENT.ZERO'})
                }
                active={(data.totalAttachments ?? 0) > 0}
                labelValue={`${data.totalAttachments || 0}`}
                icon='bi bi-paperclip'
              />

              {data.arrivedAt && (
                <IconLabelContent
                  title={intl.formatMessage({
                    id: `TICKET.TECHNICIAN.ARRIVED`,
                  })}
                  active={!!data.arrivedAt}
                  icon='bi bi-building-check'
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
